import { CircularProgress } from '@mui/material';
import React from 'react';
import './MagicButton.css';

// Local SVG icons
import { ReactComponent as HeartIcon } from 'assets/icons/heart.svg';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';

interface MagicButtonProps {
  label: string;
  icon?: 'heart' | 'plus' | React.ReactNode; // Allow 'heart' and 'plus' shortcuts
  color?: 'black' | 'purple' | 'default' | 'dark-grey' | 'grey';
  fullWidth?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  onPress: () => void;
}

const MagicButton = ({
  label,
  icon,
  color = 'default',
  fullWidth = false,
  isLoading = false,
  isDisabled = false,
  onPress,
}: MagicButtonProps) => {
  const finalOnPress = !(isDisabled || isLoading) ? onPress : undefined;

  // Resolve built-in icons
  const renderIcon = () => {
    if (icon === 'heart') return <HeartIcon />;
    if (icon === 'plus') return <PlusIcon />;
    return icon || null;
  };

  return (
    <div
      className={`magic-button ${color} ${fullWidth ? 'full-width' : ''} ${
        isDisabled ? 'disabled' : ''
      }`}
      onClick={finalOnPress}
    >
      {isLoading ? (
        <CircularProgress size={24} sx={{ color: 'white' }} />
      ) : (
        <>
          {icon && <div className="icon-container">{renderIcon()}</div>}
          <div className="label">{label}</div>
        </>
      )}
    </div>
  );
};

export default MagicButton;
